import { createSelector } from 'reselect'
import { get } from 'lodash'
import { selectCurrentCELs, selectFromCurrentCELs } from './dictionary'

export const selectRefiStatus = createSelector(
  selectCurrentCELs,
  dict => ({
    custom: dict.showCustomRefi(),
    fha: dict.showRefiForFHA(),
    isConsolidation: dict.isConsolidation(),
    15: get(dict.loans(), [0, 'refiToday', 'fix15Yr'], false),
    20: dict.show20YrRefi(),
    25: dict.show25YrRefi(),
    30: get(dict.loans(), [0, 'refiToday', 'fix30Yr'], false)
  })
)

export const selectFullLoanTotal = selectFromCurrentCELs(
  'interestForFullLoanTotal'
)
